import React from "react"
import { useTranslation } from "react-i18next"

import {
  Description,
  DescriptionList,
  DescriptionListItem,
} from "components/Products/elements"
import { ProductType } from "types"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  item: ProductType
}

type ItemType = {
  title: string
}

const ProductItem = ({ item }: Props) => {
  const { t } = useTranslation()

  const { product_type } = item
  const isList =
    t(`features.product.type.${product_type}.list.items`).length > 0

  return (
    <>
      <Description variant="h6">
        {t(`features.product.type.${product_type}.description`)}
      </Description>
      {isList && (
        <>
          <Description variant="h6">
            {t(`features.product.type.${product_type}.list.title`)}
          </Description>
          <DescriptionList>
            {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              t(`features.product.type.${product_type}.list.items`).map(
                (item: ItemType, index: number) => (
                  <DescriptionListItem key={index}>
                    {item.title}
                  </DescriptionListItem>
                ),
              )
            }
          </DescriptionList>
        </>
      )}
    </>
  )
}

export default ProductItem
